const _speed = 3;

export const speed = 100 / _speed;